import { createTracker } from 'usage-tracker-public';
import { makeUuid } from 'usage-tracker-core/common/helpers';
const sessionId = makeUuid();
export default createTracker({
  standalone: true,
  properties: {
    deviceId: sessionId
  }
});